import { OptionsObject, withSnackbar, WithSnackbarProps } from "notistack";
import * as React from "react";
import { connect } from "react-redux";

import { RootState } from "../../reducers";
import { AppRemoveSnackbar } from "../../reducers/app/action";

export interface NotificationProps {
  key: string;
  message: string | React.ReactNode;
  options?: OptionsObject | any;
  dismissed?: boolean;
}

export interface NotifierProps {
  notifications: NotificationProps[];
  removeSnackbar: (key: string) => void;
}

type Props = NotifierProps & WithSnackbarProps;

class NotifierComponent extends React.Component<Props> {
  displayed: string[] = [];

  storeDisplayed = (id: string) => {
    this.displayed = [...this.displayed, id];
  };

  shouldComponentUpdate({ notifications: newSnacks = [] }: Props) {
    if (!newSnacks.length) {
      this.displayed = [];
      return false;
    }

    const {
      notifications: currentSnacks,
      closeSnackbar,
      removeSnackbar
    } = this.props;
    let notExists = false;
    for (let i = 0; i < newSnacks.length; i += 1) {
      const newSnack = newSnacks[i];
      if (newSnack.dismissed) {
        closeSnackbar(newSnack.key);
        removeSnackbar(newSnack.key);
      }

      if (notExists) continue;
      notExists =
        notExists ||
        !currentSnacks.filter(({ key }) => newSnack.key === key).length;
    }
    return notExists;
  }

  componentDidUpdate() {
    const { notifications = [], removeSnackbar } = this.props;
    notifications.forEach(({ key, message, options = {} }) => {
      if (this.displayed.includes(key)) {
        return;
      }
      this.props.enqueueSnackbar(message, {
        ...options,
        key,
        onClose: (event: any, reason: any, key: any) => {
          if (options.onClose) {
            options.onClose(event, reason, key);
          }
          // Dispatch action to remove snackbar from redux store
          removeSnackbar(key);
        }
      });
      // Keep track of snackbars that we've displayed
      this.storeDisplayed(key);
    });
  }

  render() {
    return null;
  }
}

const mapStateToProps = (store: RootState) => ({
  notifications: store.app.notifications
});

const mapDispatchToProps = (dispatch: any) => ({
  removeSnackbar: (key: string) => {
    dispatch(new AppRemoveSnackbar(key));
  }
});

export const Notifier = withSnackbar<any>(
  connect(mapStateToProps, mapDispatchToProps)(NotifierComponent)
);
